import { safeSelect } from '@sie/web-common-utils';
import findAndDecorateWithProps from '../utils/findAndDecorateWithProps';
import ProductMeta from './ProductMeta';

var isProductMetaComponent = function isProductMetaComponent(component) {
  return safeSelect(component, 'type') === ProductMeta;
};

var findAndDecorateProductMetaProps = function findAndDecorateProductMetaProps(component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return findAndDecorateWithProps(component, props, isProductMetaComponent);
};

export default findAndDecorateProductMetaProps;